export default "__VITE_ASSET__BxRzyT6c__"